import React from 'react';

const CartContext = React.createContext({
	items: [],
	totalAmount: 0,
	addItem: (item) => {},
	removeItem: (id) => {},
	setItem: (id) => {},
	clearCart: () => {}
});

export default CartContext;
